import { AuthorizedInstallersContext } from '@authorizedInstaller/contexts/AuthorizedInstallersContext';
import { Select } from '@components/utility/selects';
import { FormControl, TextField } from '@mui/material';
import { useGetCountriesQuery } from '@services/countries';
import { useContext } from 'react';

const ContactStep = () => {
    const { data: countries, isLoading: isCountriesDataLoading } = useGetCountriesQuery();
    const {
        formik: { values, touched, errors, handleChange, handleBlur },
    } = useContext(AuthorizedInstallersContext);

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col w-full gap-4 md:flex-row">
                <FormControl className="w-full">
                    <TextField
                        name="address1"
                        label="Address"
                        value={values.address1}
                        error={touched.address1 && Boolean(errors.address1)}
                        helperText={touched.address1 && errors.address1 ? errors.address1 : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        slotProps={{
                            inputLabel: {
                                required: true,
                            },
                        }}
                    />
                </FormControl>
                <FormControl className="w-full">
                    <TextField
                        name="city"
                        label="City"
                        value={values.city}
                        error={touched.city && Boolean(errors.city)}
                        helperText={touched.city && errors.city ? errors.city : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        slotProps={{
                            inputLabel: {
                                required: true,
                            },
                        }}
                    />
                </FormControl>
            </div>
            <div className="flex flex-col w-full gap-4 md:flex-row">
                <FormControl className="w-full">
                    <Select
                        required
                        searchable
                        virtualize
                        multiple={false}
                        type="default"
                        disabled={isCountriesDataLoading}
                        fcSX={{
                            required: true,
                        }}
                        name="country_code"
                        label="Country"
                        items={countries?.map((country) => ({ label: country.label, value: country.value })) ?? []}
                        value={values.country_code}
                        error={touched.country_code && Boolean(errors.country_code)}
                        helperText={touched.country_code && errors.country_code ? errors.country_code : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    ></Select>
                </FormControl>
                <FormControl className="w-full">
                    <TextField
                        name="state"
                        label="State/Province"
                        value={values.state}
                        error={touched.state && Boolean(errors.state)}
                        helperText={touched.state && errors.state ? errors.state : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FormControl>
            </div>
            <div className="flex flex-col w-full gap-4 md:flex-row">
                <FormControl className="w-full">
                    <TextField
                        name="mobile_phone"
                        label="Phone"
                        value={values.mobile_phone}
                        error={touched.mobile_phone && Boolean(errors.mobile_phone)}
                        helperText={touched.mobile_phone && errors.mobile_phone ? errors.mobile_phone : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FormControl>
                <FormControl className="w-full">
                    <TextField
                        disabled
                        name="email"
                        label="Email"
                        value={values.email}
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email ? errors.email : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        slotProps={{
                            inputLabel: {
                                required: true,
                            },
                        }}
                    />
                </FormControl>
            </div>
        </div>
    );
};

export { ContactStep };
